import { render, staticRenderFns } from "./PcLeftbar.vue?vue&type=template&id=7bfc533c&scoped=true&"
import script from "./PcLeftbar.vue?vue&type=script&lang=js&"
export * from "./PcLeftbar.vue?vue&type=script&lang=js&"
import style0 from "./PcLeftbar.vue?vue&type=style&index=0&id=7bfc533c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfc533c",
  null
  
)

export default component.exports